
export default {
    data() {
        return {
            swiperOptions: {
                navigation: {
                    nextEl: ".swiper-expert-button-next",
                    prevEl: ".swiper-expert-button-prev",
                },
                centeredSlides: true,
                grabCursor: true,
                effect: "coverflow",
                coverflowEffect: {
                    rotate: 0,
                    stretch: 80,
                    depth: 200,
                    modifier: 1,
                    slideShadows: true,
                },
                breakpoints: {
                    1440: {
                        slidesPerView: 3.1,
                        loop: false,
                    },
                    768: {
                        slidesPerView: 2.16,
                        loop: false,
                    },
                    0: {
                        slidesPerView: "auto",
                        loop: false,
                    },
                },
            },
            sliderData: [
                {
                    name: "CORA HSU",
                    image: "Cora.JPG",
                    fullsize_image: "",
                    email: "cora@thrivestate.io",
                    phone: "916659359",
                    phone_country: {
                        id: 1,
                        name: "Taiwan",
                        phone_code: "886",
                    },
                    languages: [{ id: 1, name: "中文" }],
                },
                {
                    name: "VIVI HSU",
                    image: "Vivi.JPG",
                    fullsize_image: "",
                    email: "vivi@thrivestate.io",
                    phone: "965723452",
                    phone_country: {
                        id: 1,
                        name: "Taiwan",
                        phone_code: "886",
                    },
                    languages: [{ id: 1, name: "中文" }],
                },
                 {
                    name: "Arthur Wu",
                    image: "Arthur.JPG",
                    fullsize_image: "",
                    email: "arthur@thrivestate.io",
                    phone: "988979036",
                    phone_country: {
                        id: 1,
                        name: "Taiwan",
                        phone_code: "886",
                    },
                    languages: [{ id: 1, name: "中文" }],
                }
            ],
        };
    },

    mounted() {
        // Якщо потрібна якась додаткова логіка, можна її залишити тут
    },
};
